/** Clés de la zone Paramètres (préfixe `settings.`), fusionnées dans `fr.ts`. */
export const settingsFr = {
  'settings.title': 'Paramètres',
  'settings.subtitle': 'Organisation, marque blanche, intégrations, clés d\'API, recettes et base de connaissances.',
  'settings.tab.organization': 'Organisation',
  'settings.tab.whitelabel': 'Marque blanche',
  'settings.tab.integrations': 'Intégrations',
  'settings.tab.apikeys': 'Clés d\'API',
  'settings.tab.recipes': 'Recettes',
  'settings.tab.knowledge': 'Base de connaissances',
  'settings.tab.danger': 'Zone danger',
  'settings.save': 'Enregistrer',
  'settings.saved': 'Modifications enregistrées',
  'settings.savedPartial': 'Le serveur ne prend pas encore en charge tout ou partie de ces réglages : ils restent inchangés.',
  'settings.reset': 'Annuler les modifications',
  'settings.cancel': 'Annuler',
  'settings.close': 'Fermer',
  'settings.actions': 'Actions',
  'settings.readOnly': 'Vous pouvez consulter ces réglages, mais pas les modifier avec votre rôle.',
  'settings.error.generic': 'L\'opération a échoué. Réessayez.',

  'settings.secret.once': 'Copiez ce secret maintenant : il ne sera plus jamais affiché. En cas de perte, il faudra en générer un nouveau.',
  'settings.secret.copy': 'Copier',
  'settings.secret.copiedShort': 'Copié',
  'settings.secret.copied': 'Copié dans le presse-papiers',
  'settings.secret.copyFailed': 'Copie impossible : sélectionnez le texte manuellement.',
  'settings.secret.done': 'J\'ai copié le secret, fermer',

  'settings.org.title': 'Organisation',
  'settings.org.desc': 'Identité, fuseau horaire, langue par défaut, rétention des données et région de stockage.',
  'settings.org.name': 'Nom de l\'organisation',
  'settings.org.nameRequired': 'Le nom est obligatoire.',
  'settings.org.domain': 'Domaine',
  'settings.org.domainHint': 'Domaine de messagerie de l\'organisation (ex. tassili.dz).',
  'settings.org.domainInvalid': 'Domaine invalide (ex. exemple.dz).',
  'settings.org.timezone': 'Fuseau horaire',
  'settings.org.locale': 'Langue par défaut',
  'settings.org.localeHint': 'Appliquée aux nouveaux membres.',
  'settings.org.auditRetention': 'Rétention du journal d\'audit',
  'settings.org.auditRetentionHint': 'Au-delà, les événements sont supprimés définitivement.',
  'settings.org.recordingRetention': 'Rétention des enregistrements de sessions',
  'settings.org.recordingRetentionHint': 'Les enregistrements sont chiffrés puis supprimés à l\'échéance.',
  'settings.org.days': '{count} jours',
  'settings.org.region': 'Région de stockage des données',
  'settings.org.regionHint': 'Où sont hébergés journaux, enregistrements et documents.',
  'settings.org.region.eu': 'Europe (Francfort)',
  'settings.org.region.mena': 'Afrique du Nord / Moyen-Orient (Alger)',
  'settings.org.regionConfirmTitle': 'Changer la région de stockage ?',
  'settings.org.regionConfirmDesc': 'Les données de l\'organisation seront migrées vers « {region} ». L\'opération peut prendre plusieurs heures et est enregistrée dans le journal d\'audit.',
  'settings.org.regionConfirm': 'Migrer les données',

  'settings.wl.title': 'Marque blanche',
  'settings.wl.desc': 'Logo, couleurs et domaine personnalisé de la console pour vos clients.',
  'settings.wl.enable': 'Activer la marque blanche',
  'settings.wl.enableDesc': 'Remplace l\'identité Siraj par la vôtre dans la console et les e-mails.',
  'settings.wl.logo': 'Logo',
  'settings.wl.logoAlt': 'Logo de l\'organisation',
  'settings.wl.noLogo': 'Aucun logo',
  'settings.wl.logoUpload': 'Choisir un logo',
  'settings.wl.logoRemove': 'Retirer',
  'settings.wl.logoHint': 'PNG, JPEG, SVG ou WebP, {max} Ko maximum.',
  'settings.wl.logoType': 'Format non pris en charge : utilisez PNG, JPEG, SVG ou WebP.',
  'settings.wl.logoSize': 'Fichier trop volumineux ({max} Ko maximum).',
  'settings.wl.logoRead': 'Impossible de lire ce fichier.',
  'settings.wl.primary': 'Couleur primaire',
  'settings.wl.primaryHint': 'Barre latérale et avatars ; texte blanc dessus.',
  'settings.wl.accent': 'Couleur d\'accent',
  'settings.wl.accentHint': 'Boutons et éléments actifs.',
  'settings.wl.picker': 'Sélecteur de couleur : {label}',
  'settings.wl.hexInvalid': 'Code hexadécimal invalide (ex. #0F1623).',
  'settings.wl.contrast.title': 'Contrôle de contraste (WCAG AA)',
  'settings.wl.contrast.primary': 'Texte blanc sur la couleur primaire',
  'settings.wl.contrast.accent': 'Texte sur la couleur d\'accent',
  'settings.wl.contrast.pass': 'Conforme',
  'settings.wl.contrast.fail': 'Insuffisant',
  'settings.wl.contrast.primaryFail': 'Le contraste du texte blanc est inférieur à {min}:1 : la couleur primaire est trop claire pour être lisible.',
  'settings.wl.contrast.fix': 'Corriger automatiquement',
  'settings.wl.domain': 'Domaine personnalisé',
  'settings.wl.domainHint': 'Adresse de la console pour vos clients (ex. console.exemple.dz).',
  'settings.wl.preview': 'Aperçu en direct',
  'settings.wl.previewDesc': 'La console aux couleurs de votre marque.',
  'settings.wl.previewAlt': 'Aperçu de la console avec le logo et les couleurs choisis',
  'settings.wl.previewButton': 'Nouvelle session',
  'settings.wl.previewDisabled': 'La marque blanche est désactivée : cet aperçu n\'est pas encore appliqué.',
  'settings.wl.dns.title': 'Vérification du domaine',
  'settings.wl.dns.desc': 'Prouvez que vous contrôlez le domaine avec un enregistrement DNS.',
  'settings.wl.dns.none': 'Enregistrez un domaine personnalisé pour obtenir l\'enregistrement DNS à créer.',
  'settings.wl.dns.instructions': 'Ajoutez cet enregistrement TXT chez votre hébergeur DNS pour {domain}, puis lancez la vérification.',
  'settings.wl.dns.type': 'Type',
  'settings.wl.dns.host': 'Nom',
  'settings.wl.dns.value': 'Valeur',
  'settings.wl.dns.copy': 'Copier la valeur',
  'settings.wl.dns.check': 'Vérifier maintenant',
  'settings.wl.dns.verified': 'Vérifié',
  'settings.wl.dns.pending': 'En attente',
  'settings.wl.dns.saveFirst': 'Enregistrez le nouveau domaine avant de le vérifier.',
  'settings.wl.dns.lastCheck': 'Dernière vérification : {date}. La propagation DNS peut prendre quelques minutes.',
  'settings.wl.dns.verifiedToast': 'Domaine vérifié',
  'settings.wl.dns.pendingToast': 'Enregistrement DNS introuvable pour l\'instant : réessayez dans quelques instants.',

  'settings.int.title': 'Ticketing',
  'settings.int.desc': 'Joignez automatiquement le rapport de session au ticket de votre outil d\'assistance.',
  'settings.int.desc.freshdesk': 'Rapport de session joint au ticket Freshdesk',
  'settings.int.desc.zendesk': 'Rapport de session joint au ticket Zendesk',
  'settings.int.desc.glpi': 'Rapport de session joint au ticket GLPI',
  'settings.int.desc.jira_sm': 'Rapport de session joint à la demande Jira Service Management',
  'settings.int.status.connected': 'Connectée',
  'settings.int.status.disconnected': 'Non connectée',
  'settings.int.status.error': 'Erreur',
  'settings.int.connectedSince': 'Connectée {date}',
  'settings.int.notConnected': 'Pas encore connectée',
  'settings.int.testOk': 'dernier test réussi ({ms} ms)',
  'settings.int.testFailed': 'dernier test en échec',
  'settings.int.testFirst': 'Testez la connexion avant d\'activer l\'intégration.',
  'settings.int.configure': 'Configurer',
  'settings.int.view': 'Consulter',
  'settings.int.connect': 'Connecter',
  'settings.int.disconnect': 'Déconnecter',
  'settings.int.connectedToast': '{name} connecté',
  'settings.int.disconnectedToast': '{name} déconnecté',
  'settings.int.drawerDesc': 'Accès au service, test de connexion et correspondance des champs.',
  'settings.int.baseUrl': 'URL du service',
  'settings.int.baseUrlHint': 'Adresse HTTPS de votre instance.',
  'settings.int.urlInvalid': 'L\'URL doit commencer par https://.',
  'settings.int.account': 'Compte de service',
  'settings.int.secret': 'Jeton ou clé d\'API',
  'settings.int.secretHint': 'Stocké chiffré, jamais réaffiché.',
  'settings.int.secretKeep': 'Un jeton est enregistré. Laissez vide pour le conserver.',
  'settings.int.attach': 'Joindre le rapport de session',
  'settings.int.attachDesc': 'Ajoute automatiquement le rapport au ticket à la fin de la session.',
  'settings.int.mapping': 'Correspondance des champs',
  'settings.int.mappingDesc': 'Champ du ticket qui reçoit chaque information du rapport.',
  'settings.int.mappingFor': 'Champ du ticket pour : {field}',
  'settings.int.field.subject': 'Sujet',
  'settings.int.field.description': 'Description',
  'settings.int.field.technician': 'Technicien',
  'settings.int.field.duration': 'Durée',
  'settings.int.field.summary': 'Résumé IA',
  'settings.int.field.device': 'Appareil',
  'settings.int.field.rating': 'Évaluation',
  'settings.int.test': 'Tester la connexion',
  'settings.int.saveBeforeTest': 'Enregistrez vos modifications avant de tester.',
  'settings.int.testOkLong': 'Connexion réussie ({ms} ms).',
  'settings.int.testError.ok': 'Connexion réussie.',
  'settings.int.testError.invalid_url': 'URL invalide : une adresse HTTPS est requise.',
  'settings.int.testError.unauthorized': 'Accès refusé : vérifiez le compte et le jeton.',
  'settings.int.testError.unreachable': 'Service injoignable : vérifiez l\'adresse et le réseau.',

  'settings.wh.title': 'Webhooks sortants',
  'settings.wh.desc': 'Recevez les événements Siraj sur vos systèmes. Chaque envoi est signé (HMAC-SHA256) avec le secret du webhook.',
  'settings.wh.add': 'Ajouter un webhook',
  'settings.wh.addDesc': 'Siraj enverra une requête POST signée à cette adresse.',
  'settings.wh.create': 'Créer le webhook',
  'settings.wh.url': 'URL de destination',
  'settings.wh.urlInvalid': 'L\'URL doit commencer par https://.',
  'settings.wh.events': 'Événements',
  'settings.wh.enabled': 'Actif',
  'settings.wh.toggle': 'Activer ou désactiver le webhook {url}',
  'settings.wh.last': 'Dernier envoi',
  'settings.wh.never': 'Jamais',
  'settings.wh.empty': 'Aucun webhook configuré.',
  'settings.wh.secretHint': 'Secret se terminant par {hint}',
  'settings.wh.secretTitle': 'Secret de signature du webhook',
  'settings.wh.secretDesc': 'Utilisez-le pour vérifier la signature des requêtes reçues.',
  'settings.wh.rotate': 'Renouveler le secret',
  'settings.wh.rotateTitle': 'Renouveler le secret ?',
  'settings.wh.rotateDesc': 'L\'ancien secret cesse immédiatement de fonctionner. Mettez à jour votre récepteur avec le nouveau.',
  'settings.wh.delete': 'Supprimer le webhook',
  'settings.wh.deleteTitle': 'Supprimer ce webhook ?',
  'settings.wh.deleted': 'Webhook supprimé',
  'settings.wh.deliveries': 'Historique des envois',
  'settings.wh.noDeliveries': 'Aucun envoi pour le moment.',
  'settings.wh.date': 'Date',
  'settings.wh.event': 'Événement',
  'settings.wh.result': 'Résultat',
  'settings.wh.attempt': 'Tentative',
  'settings.wh.status.success': 'Réussi',
  'settings.wh.status.failed': 'Échec',
  'settings.wh.replay': 'Rejouer cet envoi',
  'settings.wh.replayed': 'Envoi rejoué',

  'settings.keys.title': 'Clés d\'API',
  'settings.keys.desc': 'Accès programmatique à l\'API Siraj. Chaque clé a ses propres portées et peut expirer.',
  'settings.keys.create': 'Créer une clé',
  'settings.keys.createDesc': 'Limitez la clé aux seules portées nécessaires.',
  'settings.keys.generate': 'Générer la clé',
  'settings.keys.name': 'Nom',
  'settings.keys.namePlaceholder': 'Ex. Export BI nocturne',
  'settings.keys.expiry': 'Expiration',
  'settings.keys.expiryDays': '{count} jours',
  'settings.keys.expiryNever': 'Jamais',
  'settings.keys.scopes': 'Portées',
  'settings.keys.scopesHint': 'Choisissez au moins une portée. Une clé ne peut pas dépasser vos propres droits.',
  'settings.keys.presetRead': 'Lecture seule',
  'settings.keys.presetNone': 'Tout décocher',
  'settings.keys.created': 'Créée le',
  'settings.keys.lastUsed': 'Dernier usage',
  'settings.keys.neverUsed': 'Jamais utilisée',
  'settings.keys.expires': 'Expire',
  'settings.keys.noExpiry': 'Sans expiration',
  'settings.keys.expired': 'Expirée',
  'settings.keys.empty': 'Aucune clé d\'API',
  'settings.keys.emptyDesc': 'Créez une clé pour intégrer Siraj à vos outils.',
  'settings.keys.secretTitle': 'Votre nouvelle clé d\'API',
  'settings.keys.secretDesc': 'Elle donne accès à votre organisation selon ses portées.',
  'settings.keys.revoke': 'Révoquer',
  'settings.keys.revokeNamed': 'Révoquer la clé {name}',
  'settings.keys.revokeTitle': 'Révoquer cette clé ?',
  'settings.keys.revokeDesc': 'Les applications qui utilisent « {name} » perdront l\'accès immédiatement. Cette action est irréversible.',
  'settings.keys.revoked': 'Clé révoquée',

  'settings.rcp.title': 'Recettes d\'organisation',
  'settings.rcp.desc': 'Procédures de dépannage réutilisables : approbation, signature puis déploiement progressif sur le parc.',
  'settings.rcp.mine': 'Mes recettes',
  'settings.rcp.library': 'Bibliothèque officielle',
  'settings.rcp.official': 'Officielle',
  'settings.rcp.new': 'Nouvelle recette',
  'settings.rcp.edit': 'Modifier',
  'settings.rcp.editSignedNote': 'Cette recette est signée : la modifier crée une nouvelle version à faire approuver à nouveau.',
  'settings.rcp.name': 'Nom',
  'settings.rcp.description': 'Description',
  'settings.rcp.steps': 'Étapes',
  'settings.rcp.stepsHint': 'Une étape par ligne.',
  'settings.rcp.status.draft': 'Brouillon',
  'settings.rcp.status.pending_approval': 'En approbation',
  'settings.rcp.status.signed': 'Signée',
  'settings.rcp.meta': 'Par {author} · mise à jour le {date}',
  'settings.rcp.signature': 'signature {sig}…',
  'settings.rcp.approvedBy': 'approuvée par {name}',
  'settings.rcp.submit': 'Soumettre à approbation',
  'settings.rcp.submitted': 'Recette soumise à approbation',
  'settings.rcp.approve': 'Approuver et signer',
  'settings.rcp.signed': 'Recette signée',
  'settings.rcp.reject': 'Renvoyer en brouillon',
  'settings.rcp.rejected': 'Recette renvoyée en brouillon',
  'settings.rcp.deploy': 'Déployer',
  'settings.rcp.delete': 'Supprimer',
  'settings.rcp.deleteTitle': 'Supprimer cette recette ?',
  'settings.rcp.deleted': 'Recette supprimée',
  'settings.rcp.import': 'Ajouter à mon organisation',
  'settings.rcp.imported': 'Recette ajoutée comme brouillon',
  'settings.rcp.empty': 'Aucune recette',
  'settings.rcp.emptyDesc': 'Créez une recette ou importez-en une depuis la bibliothèque officielle.',
  'settings.rcp.rollout.title': 'Déploiement progressif',
  'settings.rcp.rollout.stages': 'Paliers du déploiement',
  'settings.rcp.rollout.machines': '{count} machine(s)',
  'settings.rcp.rollout.failures': '{failed} échec(s) · {pct} %',
  'settings.rcp.rollout.next': 'Prochain palier',
  'settings.rcp.rollout.pending': 'En attente',
  'settings.rcp.rollout.status.running': 'En cours',
  'settings.rcp.rollout.status.halted': 'Arrêté',
  'settings.rcp.rollout.status.completed': 'Terminé',
  'settings.rcp.rollout.thresholdLabel': 'Seuil d\'échecs (%)',
  'settings.rcp.rollout.thresholdInvalid': 'Entre 0 et 100.',
  'settings.rcp.rollout.threshold': 'Arrêt automatique si plus de {pct} % des machines d\'un palier échouent.',
  'settings.rcp.rollout.start': 'Démarrer (1 machine)',
  'settings.rcp.rollout.restart': 'Relancer le déploiement',
  'settings.rcp.rollout.advance': 'Passer au palier suivant',
  'settings.rcp.rollout.halt': 'Arrêter',
  'settings.rcp.rollout.autoHalted': 'Arrêt automatique : {pct} % d\'échecs, au-dessus du seuil de {threshold} %. Le déploiement ne continue pas.',
  'settings.rcp.rollout.autoHaltedToast': 'Déploiement arrêté automatiquement : seuil d\'échecs dépassé',
  'settings.rcp.rollout.manualHalted': 'Déploiement arrêté manuellement.',
  'settings.rcp.rollout.completed': 'Déploiement terminé sur tous les paliers.',
  'settings.rcp.rollout.completedToast': 'Déploiement terminé',

  'settings.kb.title': 'Base de connaissances',
  'settings.kb.desc': 'Documents de votre entreprise que l\'assistant IA consulte pour répondre (RAG). Ils restent privés à votre organisation.',
  'settings.kb.drop': 'Glissez vos documents ici',
  'settings.kb.formats': 'Formats : {formats} · {max} Mo maximum par fichier',
  'settings.kb.add': 'Ajouter des documents',
  'settings.kb.added': '« {name} » ajouté, indexation en cours',
  'settings.kb.unsupported': '« {name} » : format non pris en charge.',
  'settings.kb.tooLarge': '« {name} » dépasse {max} Mo.',
  'settings.kb.name': 'Document',
  'settings.kb.status': 'Indexation',
  'settings.kb.status.queued': 'En file',
  'settings.kb.status.indexing': 'Indexation',
  'settings.kb.status.indexed': 'Indexé',
  'settings.kb.status.failed': 'Échec',
  'settings.kb.error.unsupported_type': 'Format non pris en charge',
  'settings.kb.error.too_large': 'Fichier trop volumineux',
  'settings.kb.error.extraction_failed': 'Texte non extractible (scan ou fichier protégé)',
  'settings.kb.chunks': 'Passages',
  'settings.kb.added.col': 'Ajouté',
  'settings.kb.retry': 'Relancer l\'indexation de {name}',
  'settings.kb.delete': 'Supprimer {name}',
  'settings.kb.deleteTitle': 'Supprimer ce document ?',
  'settings.kb.deleteDesc': '« {name} » sera retiré de l\'index : l\'assistant ne pourra plus s\'en servir.',
  'settings.kb.deleteConfirm': 'Supprimer',
  'settings.kb.deleted': 'Document supprimé',
  'settings.kb.empty': 'Aucun document',
  'settings.kb.emptyDesc': 'Ajoutez procédures, chartes ou guides pour enrichir les réponses de l\'assistant.',
  'settings.kb.statDocs': 'Documents',
  'settings.kb.statInProgress': '{count} en cours d\'indexation',
  'settings.kb.statChunks': 'Passages indexés',
  'settings.kb.statChunksHint': 'Disponibles pour l\'assistant',
  'settings.kb.kb': 'Ko',
  'settings.kb.mb': 'Mo',

  'settings.danger.exportTitle': 'Exporter les données',
  'settings.danger.exportDesc': 'Téléchargez un export JSON de l\'organisation (paramètres, membres, parc, politiques, sessions et journal d\'audit).',
  'settings.danger.export': 'Exporter les données',
  'settings.danger.exported': 'Export téléchargé',
  'settings.danger.noExport': 'L\'export requiert les droits de gestion des paramètres et d\'export d\'audit.',
  'settings.danger.deleteTitle': 'Supprimer l\'organisation',
  'settings.danger.deleteDesc': 'Supprime définitivement l\'organisation et toutes ses données. Pensez à exporter vos données avant.',
  'settings.danger.delete': 'Supprimer l\'organisation',
  'settings.danger.ownerOnly': 'Seul le propriétaire de l\'organisation peut la supprimer.',
  'settings.danger.step1Title': 'Supprimer l\'organisation ?',
  'settings.danger.step1Warning': 'Cette action est irréversible.',
  'settings.danger.consequence1': 'Appareils, membres, politiques et journaux sont supprimés.',
  'settings.danger.consequence2': 'Les clés d\'API, webhooks et intégrations cessent de fonctionner.',
  'settings.danger.consequence3': 'L\'abonnement est résilié sans remboursement du mois en cours.',
  'settings.danger.understand': 'Je comprends que cette suppression est définitive.',
  'settings.danger.continue': 'Continuer',
  'settings.danger.step2Title': 'Dernière confirmation',
  'settings.danger.step2Desc': 'Saisissez le nom exact de l\'organisation, « {name} », pour confirmer.',
  'settings.danger.typeName': 'Nom de l\'organisation',
  'settings.danger.confirmDelete': 'Supprimer définitivement',
  'settings.danger.deleted': 'Organisation supprimée',
  'settings.danger.deleteFailed': 'Suppression impossible : vérifiez le nom saisi et vos droits.',

  // Écran « Mon profil » (src/features/profile)
  'profile.account': 'Compte',
  'profile.accountDesc': 'Informations de connexion de votre compte Siraj.',
  'profile.name': 'Nom',
  'profile.email': 'E-mail',
  'profile.twoFactor': 'Double authentification',
  'profile.twoFactorOn': 'Activée',
  'profile.twoFactorOff': 'Désactivée',
  'profile.preferences': 'Préférences',
  'profile.preferencesDesc': 'Langue et thème d\'affichage de la console.',
  'profile.organizations': 'Organisations',
  'profile.organizationsDesc': 'Organisations auxquelles votre compte est rattaché et votre rôle dans chacune.',
  'profile.active': 'Active',
  'profile.switch': 'Basculer',
} as const;
